//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
  },
  
  props: {
    title: {
      default: 'This is a sample post',
    },
    content: {},
    email: {},
    author: {
      default: 'Anonymous',
    },
    permalink: {
      default: '#',
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {

  },
  
  created() {
    
  },
  mounted() {

  },
};




// WEBPACK FOOTER //
// ./scripts/vue/PostBanner.vue